<ca-rbr-section>
    <div class="flex flex-col p-2 gap-y-4">
        <div class="flex justify-between items-center py-[2px]">
            @if (level(); as level) {
                <p class="ca-rbr-level-name ca-text-xl ca-bold m-0">{{ level.number | levelName | translate }}</p>
            }
            <div class="flex gap-x-3 items-center">
                <ca-rbr-add-rooms [levels]="levels()" [level]="level()" (setRooms)="setRooms.emit($event)" />
                <button mat-icon-button class="ca-button" [cdkMenuTriggerFor]="levelActionsMenu" [cdkMenuPosition]="[dropDownMenuPosition]">
                    <ca-icon icon="more-horizontal" class="ca-icon-s-24-p-0-f-24"></ca-icon>
                </button>
            </div>
        </div>

        @if (level(); as level) {
            @if (level.roomsData.length > 0) {
                <ca-rbr-room-list [columns]="columns" [level]="level" />
            }
        } @else {
            <ca-spinner
                [diameter]="48"
                [text]="'RBR.ROOM_LIST.LOADER_TEXT' | translate"
                [subtext]="'RBR.ROOM_LIST.LOADER_SUBTEXT' | translate"
            />
        }
    </div>
</ca-rbr-section>

<ng-template #levelActionsMenu>
    <div class="ca-menu" cdkMenu>
        <button
            class="ca-menu-item h-full flex gap-x-2 items-center py-2"
            (click)="onDeleteLevel()"
            [caConfirm]="{
                uuid: deleteLevelUUID,
                title: 'CONFIRM.DELETE_LEVEL.TITLE' | translate,
                content: 'CONFIRM.DELETE_LEVEL.CONTENT' | translate,
                cancelBtn: 'COMMON.BUTTONS.CANCEL' | translate,
                confirmBtn: 'COMMON.BUTTONS.DELETE' | translate,
                disabled: !level().roomsData.length
            }"
        >
            <ca-icon icon="trash-outline" class="ca-icon-s-24-p-0-f-24"></ca-icon>
            <span class="ca-rbr-menu-item-text ca-text-md">{{ 'RBR.ROOM_LIST.DELETE_LEVEL' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #roomActionsMenu let-roomId>
    <div class="ca-menu" cdkMenu>
        <button cdkMenuItem class="ca-menu-item h-full flex gap-x-2 items-center py-2" (click)="deleteRoom.emit(roomId)">
            <ca-icon icon="trash-outline" class="ca-icon-s-24-p-0-f-24"></ca-icon>
            <span class="ca-rbr-menu-item-text ca-text-md">{{ 'RBR.ROOM_LIST.DELETE_ROOM' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #roomNameCellEl let-context>
    <ca-rbr-room-editor [selectedRoomId]="context.row.id">
        <span
            matTooltipTouchGestures="auto"
            matTooltipShowDelay="300"
            matTooltipPosition="above"
            matTooltipClass="ca-tooltip ca-tooltip-long"
            [matTooltip]="context.row.name"
            class="ca-text-md ca-bold cursor-pointer"
        >
            {{ context.row.name }}
        </span>
    </ca-rbr-room-editor>
</ng-template>

<ng-template #roomAreaCellEl let-context>
    <span class="ca-text-md">
        {{ context.row.area | valueWithUnit: measurementUnit.SquareMeter }}
    </span>
</ng-template>

<ng-template #roomHeightCellEl let-context>
    <span class="ca-text-md">{{ context.row.height | valueWithUnit: measurementUnit.Meter }}</span>
</ng-template>

<ng-template #roomTypeCellEl let-context>
    <span class="ca-text-md">{{ context.row.type | roomType }}</span>
</ng-template>

<ng-template #roomIsCooledCellEl let-context>
    <ca-toggle [value]="context.row.isCooled" (valueChanged)="toggleCooling.emit({ roomId: context.row.id, cooling: $event })" />
</ng-template>

<ng-template #roomCoolingLoadCellEl let-context>
    <span class="ca-text-md">{{ context.row.coolingLoad | valueWithUnit: measurementUnit.KiloWatt }}</span>
</ng-template>

<ng-template #roomIsHeatedCellEl let-context>
    <ca-toggle [value]="context.row.isHeated" (valueChanged)="toggleHeating.emit({ roomId: context.row.id, heating: $event })" />
</ng-template>

<ng-template #roomHeatingLoadCellEl let-context>
    <span class="ca-text-md">{{ context.row.heatingLoad | valueWithUnit: measurementUnit.KiloWatt }}</span>
</ng-template>

<ng-template #roomActionsCellEl let-context>
    <div class="flex justify-between items-center w-full">
        <button
            mat-icon-button
            class="ca-button ca-button-s"
            [cdkMenuTriggerFor]="roomActionsMenu"
            [cdkMenuTriggerData]="{ $implicit: context.row.id }"
            [cdkMenuPosition]="[dropDownMenuPosition]"
        >
            <ca-icon icon="more-horizontal" class="ca-icon-s-24-p-0-f-24"></ca-icon>
        </button>
        <button mat-icon-button class="ca-button ca-button-s" (click)="editRoom.emit(context.row.id)">
            <ca-icon icon="chevron-right" class="ca-icon-s-24-p-0-f-24"></ca-icon>
        </button>
    </div>
</ng-template>
